import React from "react";
import { Container, Image } from "react-bootstrap";
import constants from "../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import '../css/note-edit.css'
import Api from "../api/Api";

const NoteEditNote = ({ name, note, showEditModal, setShowEditModal}) => {

  const [modifiedNote, setModifiedNote] = useState({
    text: note.text || "",
    image: note.image || null,
    note_type: name,
  });
  
  const [localImage, setLocalImage] = useState(note?.image || null);
  
  const setValue = (field, value) => {
    setModifiedNote({ ...modifiedNote, [field]: value });
  };

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleString("hu-HU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).replace(",", "");

  const saveChanges = async () => {
    if (window.confirm("Biztosan beküldi a megjegyzést?\r\nKép csere/törlés esetén a mentés végleges, a kép nem visszaállítható!")) {
      const param = {
        note_id: note.id,
        note_type: name,
        note: modifiedNote
      };
      const result = await Api.updateNote(param);
      if (result.success === true) {
        setModifiedNote({ 
          text: "", 
          image: null,
          note_type: name
        });
        setLocalImage(null);
        setShowEditModal(false);
      } else {
        console.log("Mentés sikertelen vagy hiba történt.");
      }
    }
  };

  const imageSrc = localImage?.startsWith("blob:")
    ? localImage
    : constants.BASE_URL + localImage;


  return (
    <Container className="edit-note-block">
        <div className="note-info d-flex justify-content-between align-items-center">
          <div className="note-info-left d-flex align-items-center">
            <div className="note-created_by">{note.manpower_name}</div>
          </div>
          <div className="note-info-right d-flex align-items-center">
            <div className="note-created_at">
              {formatDate(note.created_at)}
            </div>
          </div>
        </div>

        <textarea 
          placeholder="Írj egy megjegyzést..." 
          value={modifiedNote.text}
          onChange={(e) => setValue("text", e.target.value)}
        />

      <div className={`${ localImage ? "note-file-input-outer-edit" : "note-file-input-outer mt-3"}`}>
        {localImage ? (
          <div className="note-image pt-2">
            <Image src={imageSrc} thumbnail className="img-thumbnail-edit" />
            <span 
              className="delete-note-icon" 
              onClick={() => {
                setLocalImage(null);
                setValue("image", null);
              }}
            >
              <FontAwesomeIcon icon={"xmark"} />
            </span>
          </div>
        ) : (
            <input 
              type="file" 
              name="image" 
              className="note-file-input" 
              accept="image/*" 
              capture="environment"
              onChange={(e) => {
                if (e.target.files.length > 0) {
                  const file = e.target.files[0];
                  setLocalImage(URL.createObjectURL(file));
                  setValue("image", file);
                }
              }}
            />
        )}
      </div>

      <div className="note-edit-buttons row pt-3">
        <div className="col-4 px-1">
          <button 
            className={`btn button w-100 button-gray`}
            onClick={()=> setShowEditModal(false)}
          >
              Mégse
          </button>
        </div>
        <div className="col-8 px-1">
          <button 
            className={"btn button w-100"}
            onClick={saveChanges}
          >Mentés</button>
        </div>
      </div>
    </Container>
  );
};

export default NoteEditNote;
